import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import style from './Markdown.module.css';

const Markdown = ({ children }) => {
  return (
    <ReactMarkdown
      source={children}
      escapeHtml={false}
      className={style['markdown']}
    />
  );
};

Markdown.propTypes = {
  children: PropTypes.string.isRequired
};

export default Markdown;
